import { Component, OnInit,Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import { Router,RouterModule} from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-appointmentrequest',
  templateUrl: './appointmentrequest.component.html',
  styleUrls: ['./appointmentrequest.component.css']
})
export class AppointmentrequestComponent implements OnInit {
  @Input() value:any;
  task = {
    perId:this.loginService.personId,
    notes:undefined,
    startDate:new Date().getFullYear() + '-' + (new Date().getMonth()+1) + '-'+ new Date().getDate(),
    dueDate:null,
    taskType:'CA'
  }
  noteSize:any = 0;
  status:Boolean = false;
  appointment:Boolean = true;
  apptDate:any;
  days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];

  constructor(public toastService:ToastrService, public loginService:LoginService, public router:Router) { }

  ngOnInit() {
    if(this.value != undefined){
      this.task.notes = this.value.action.notes;
      this.status = true;
    }
    this.load();
  }
  onQuickTextChanged(event) {
    this.noteSize = this.task.notes.length;
  }
  save(){
    this.task.dueDate = this.loginService.staticData.get("TASKDUEDATES").find(obj => obj.value == 'CA').name;
    this.loginService.saveTask(this.task).subscribe((data)=>{
      if(data['message']=='success'){
        this.toastService.success('Successfully saved your request','My Requests');
        $("#closeConfirm").click();
        this.router.navigate(['requests']);
      }
      else{
        this.toastService.error('Record not saved: Please review or contact Help Desk','My Requests');
      }
    },error=>{
      this.toastService.error('Record not saved: Please review or contact Help Desk','My Requests');
    })
  }
  load(){
    let request = {
      perId: this.loginService.personId
    }
    this.loginService.loadAppointment(request).subscribe((data)=>{
      if(data['@cnt']==1){
        this.appointment = false;
        let day = this.days[new Date(data['@apptDate'].replace(/-/g, '\/')).getDay()];
        let date = data['@apptDate'].replace(/-/g, '\/').split(' ')[0].split('/')[1] +'/' + data['@apptDate'].replace(/-/g, '\/').split(' ')[0].split('/')[2] + '/' +data['@apptDate'].replace(/-/g, '\/').split(' ')[0].split('/')[0];
        let time = new Date(data['@apptDate'].replace(/-/g, '\/')).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        this.apptDate = day + '    ' + time + '     ' + date;
      }
      else{
        this.appointment = true;
      }
    },error=>{
      this.appointment = true;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/appointmentrequest/appointmentrequest.component.ts